import i18n from "@/i18n";
import { ContractsTypes } from "fs-pb-vue2/data/enums/contractsTypes";
import { BaseContractVueGB } from "./BaseContractVueGB";

/** Модель представления счета */
export class DepositVueGB extends BaseContractVueGB {

  async callAction(action: () => Promise<void>) {
    await action();
  }

  /**Список доступных операций */
  get actions(): Array<any> {
    const actions: Array<any> = [];
    if (this.contract) {
      /**Информация*/
      actions.push({
        text: i18n.t("main.contracts.actions.info"),
        iconClass: "information-action-icon",
        action: () => {
          this.$router.push({ path: this.$route.fullPath, query: { 'details': 'true' } });
        }
      });
      /**Прогнозный доход по вкладу*/
      // actions.push({
      //   text: i18n.t("main.contracts.actions.contractForecastData"),
      //   iconClass: "forecast-action-icon",
      //   action: () => {
      //     this.$router.push({ path: this.$route.fullPath, query: { 'forecast': 'true' } });
      //   }
      // });
      /**Действие запроса выписки по счету*/
      actions.push({
        text: i18n.t("main.contracts.actions.statement"),
        iconClass: "statement-icon",
        action: () => {
          this.$router.push(`/statement/${this.contract.Data.Id}/0`);
        }
      });
      /**Действие запроса реквизитов счета */
      actions.push({
        text: i18n.t("main.contracts.actions.requisits"),
        iconClass: "requisits-icon",
        action: () => {
          this.$router.push({ path: this.$route.fullPath, query: { 'reqs': 'true' } });
        }
      });
    }
    if (this.configStore.apiData.OperationCodeOfCloseDeposit && this.contract.IsOpen && this.contract.Data.CanCloseOnline == "1") {
      actions.push({
        text: this.$i18n.t("main.contracts.actions.closeDeposit"),
        iconClass: "close-deposit-icon",
        action: () => {
          this.$router.push(
            `/operation/0/${this.configStore.apiData.OperationCodeOfCloseDeposit}?_categoryName=${this.$i18n.t("main.contracts.actions.closeDeposit")}&contract=${this.contract.Data.ReferenceId}&sum=${this.contract.Data.Rest}`
          );
        }
      });
    }
    return actions;
  }

  /**Список информации */
  get details(): Array<any> {
    let details: Array<any> = [];
    if (this.contract) {
      details = [];
      
      if(this.contract.IsOpen) {
        // Остаток
        details.push({
          name: i18n.t("main.contracts.details.rest"),
          textVal: `${this.contract.Rest} ${this.contract.Currency}`
        });
        // Заблокировано на счете
        details.push({
          name: i18n.t("main.contracts.details.lockedSum"),
          textVal: `${this.contract.CalcLocked} ${this.contract.Currency}`
        });

        if (this.contract.Data.ArrestSum > 0) {
          // - из них арестовано
          details.push({
            name: i18n.t("main.contracts.details.arrestSum"),
            textVal: `${this.contract.ArrestSum} ${this.contract.Currency}`
          });
        }

        if (
          this.contract.Data.MinDepositRest > 0 && 
          this.contract.Data.ContractType == ContractsTypes.DepositAccounts
        ) {
          // - из них неснижаемый остаток
          details.push({
            name: i18n.t("main.contracts.details.minDepositum"),
            textVal: `${this.contract.MinDepositRest} ${this.contract.Currency}`
          });
        }

        // Доступно
        details.push({
          name: i18n.t("main.contracts.details.disposableLimit"),
          textVal: `${this.contract.DisposableLimit} ${this.contract.Currency}`
        });
      }

      if ( 
        this.contract.Data.IncomeSum > 0 && 
        this.contract.Data.ContractType == ContractsTypes.DepositAccounts 
      ) {
        // Полученный доход
        details.push({
          name: i18n.t("main.contracts.details.incomeSum"),
          textVal: `${this.contract.IncomeSum} ${this.contract.Currency}`
        });
      }

      if (this.contract.IsOpen && this.contract.Data.PercentRate > 0) {
        // Процентная ставка
        details.push({
          name: i18n.t("main.contracts.details.percentRate"),
          textVal: `${this.contract.Data.PercentRate} %` 
        });
      }
      // Основной счет
      details.push({
        name: i18n.t("main.contracts.details.mainAccount"),
        textVal: this.contract.Data.MainAccount
      });
      // Валюта договора
      details.push({
        name: i18n.t("main.contracts.details.currencyDeposit"),
        textVal: this.contract.Currency
      });

      if (this.contract.Data.Number) {
        // Номер договора
        details.push({
          name: i18n.t("main.contracts.details.contractNum"),
          textVal: this.contract.Data.Number
        });
      }

      if (this.contract.Data.ContractType == ContractsTypes.TimeAccounts) {
        // Тип вклада
        details.push({
          name: i18n.t("main.contracts.details.typeDeposit"),
          textVal: this.contract.ContractType
        });
      }

      if (this.contract.Data.ContractType == ContractsTypes.DepositAccounts) {
        // Тип счёта
        details.push({
          name: i18n.t("main.contracts.details.type"),
          textVal: this.contract.ContractType
        });
      }

      if (this.contract.Data.ContractType == ContractsTypes.TimeAccounts) {
        if(this.contract.DepositPeriod){
          //Срок (дней)
          details.push({
            name: i18n.t("main.contracts.details.depositPeriod"),
            textVal: `${this.contract.DepositPeriod}`
          });
        }

        if(this.contract.Data.Capitalization){
          //Наличие капитализации
          details.push({
            name: i18n.t("main.contracts.details.isCapitalization"),
            textVal: this.contract.Data.Capitalization
              ? i18n.t("main.contracts.details.yes")
              : i18n.t("main.contracts.details.no")
          });
        }

        if(this.contract.PayPercentsPeriod){
          // Выплата процентов
          details.push({
            name: i18n.t("main.contracts.details.payPercentsPeriod"),
            textVal: `${this.contract.PayPercentsPeriod}`
          });
        }
      }

      // Состояние
      details.push({
        name: i18n.t("main.contracts.details.state"),
        textVal: this.contract.IsOpen
          ? i18n.t("main.contracts.details.open")
          : i18n.t("main.contracts.details.close")
      });

      if (this.contract.Data.DateOpen) {
        // Дата открытия
        details.push({
          name: i18n.t("main.contracts.details.dateOpen"),
          textVal: this.contract.DateOpen
        });
      }

      if (this.contract.Data.DateClose) {
        // Дата закрытия
        details.push({
          name: i18n.t("main.contracts.details.dateClose"),
          textVal: this.contract.DateClose
        });
      }

      if (
        this.contract.Data.ContractType == ContractsTypes.TimeAccounts && 
        this.contract.IsOpen
      ) {
        if(this.contract.DateEnd){
          // Окончание срока
          details.push({
            name: i18n.t("main.contracts.details.dateEnd"),
            textVal: this.contract.DateEnd
          });
        }
        // Частичное снятие
        details.push({
          name: i18n.t("main.contracts.details.partCanWithdraw"),
          textVal: this.contract.Data.CanWithdraw
            ? i18n.t("main.contracts.details.enable")
            : i18n.t("main.contracts.details.disable")
        });

        if(this.contract.Data.RemCanWithdraw){
          // Ограничения снятия
          details.push({
            name: i18n.t("main.contracts.details.remCanWithdraw"),
            textVal: this.contract.Data.RemCanWithdraw
          });
        }
      }

      if (
        this.contract.Data.ContractType == ContractsTypes.DepositAccounts && 
        this.contract.IsOpen
      ) {
        // Списание
        details.push({
          name: i18n.t("main.contracts.details.canWithdraw"),
          textVal: this.contract.Data.CanWithdraw
            ? i18n.t("main.contracts.details.enable")
            : i18n.t("main.contracts.details.disable")
        });
      }

      if(this.contract.IsOpen) {
        // Пополнение
        details.push({
          name: i18n.t("main.contracts.details.canDeposit"),
          textVal: this.contract.Data.CanDeposit
            ? i18n.t("main.contracts.details.enable")
            : i18n.t("main.contracts.details.disable")
        });
      }
      
      if (
        this.contract.Data.ContractType == ContractsTypes.TimeAccounts && 
        this.contract.Data.RemCanDeposit
      ) {
        // Ограничения пополнения
        details.push({
          name: i18n.t("main.contracts.details.remCanDeposit"),
          textVal: this.contract.Data.RemCanDeposit
        });
      }
    }
    return details;
  }
}